@if (resumo(); as dados) {
  <h5 class="title">Detalhes da sua solicitação de aposentadoria</h5>
  @if (requerimento()?.protocolo; as protocolo) {
    <p class="protocolo">Protocolo: {{ protocolo }}</p>
  }

  <div class="d-flex flex-wrap cards">
    @if (statusSolicitacao() === statusDocumentacaoNaoValidada) {
      <div class="card-badge">
        <span class="badge">Pendente</span>
        <vivest-card class="card-status" variant="elevated" [fullWidth]="true" style="--vivest-space-md: 24px;">
          <label>Documentação não validada</label>
          <p>Alguns documentos que você nos enviou não puderam ser validados.</p>
          <div class="top-16 mb-3">
            <vivest-button variant="secondary" size="md" [fullWidth]="true" (click)="abrirDocModal()">
              Reenviar documentos
            </vivest-button>
          </div>
        </vivest-card>
      </div>
    } @else {
      <div>
        <vivest-card class="card-status" variant="elevated" [fullWidth]="true">
          <label>Status da solicitação</label>
          <p>{{ statusSolicitacao() }}</p>
          @if (emAnalise()) {
            <span class="previsao">Previsão: {{ diasUteisPrevisao }} {{ diasUteisPrevisao === 1 ? 'dia útil' : 'dias úteis' }}</span>
          }
        </vivest-card>
      </div>
    }
    <div>
      <vivest-card variant="elevated" [fullWidth]="true">
        <label>Valor líquido mensal</label>
        <p>R$ {{ formatarValor(dados.valorLiquidoMensal) }}</p>
      </vivest-card>
    </div>
    <div>
      <vivest-card variant="elevated" [fullWidth]="true">
        <label>Primeiro benefício em</label>
        <p>{{ primeiroBeneficio() }}</p>
      </vivest-card>
    </div>
  </div>

  @if (antecipacao(); as antecipacao) {
    <div class="detalhes antecipacao">
      <h6 class="subtitulo">Antecipação do benefício</h6>
      <table>
        <tbody>
          <tr>
            <td>Valor Bruto da antecipação do saldo</td>
            <td class="valor">
              R$ {{ formatarValor(antecipacao.valorBruto) }} ({{ formatarNumero(antecipacao.percentual) }}%)
            </td>
          </tr>
          <tr>
            <td>Valor do Imposto de Renda da antecipação do saldo</td>
            <td class="valor">R$ {{ formatarValor(antecipacao.valorImpostoRenda) }}</td>
          </tr>
          <tr>
            <td>Valor Líquido da antecipação do saldo</td>
            <td class="valor">R$ {{ formatarValor(antecipacao.valorLiquido) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  }

  <div class="detalhes beneficio">
    <h6 class="subtitulo">Benefício</h6>
    <table>
      <tbody>
        <tr>
          <td>Forma de recebimento</td>
          <td class="valor">{{ formaRecebimento() }}</td>
        </tr>
        <tr>
          <td>Adiantamento de benefício</td>
          <td class="valor">{{ adiantamentoBeneficio() }}</td>
        </tr>
        <tr>
          <td>Saldo geral</td>
          <td class="valor">R$ {{ formatarValor(saldoGeral()) }}</td>
        </tr>
        <tr>
          <td>Valor Bruto Mensal (estimado)</td>
          <td class="valor">R$ {{ formatarValor(dados.valorBrutoMensal) }}</td>
        </tr>
        <tr>
          <td>Valor do Imposto de Renda (estimado)</td>
          <td class="valor valor--desconto">
            R$ {{ formatarValor(dados.valorImpostoRenda) }} ({{ formatarNumero(dados.percentualImpostoRenda) }}%)
          </td>
        </tr>
        <tr>
          <td>Valor Líquido Mensal do Benefício (estimado)</td>
          <td class="valor valor--liquido">R$ {{ formatarValor(dados.valorLiquidoMensal) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
}

<app-pdf-document
  class="documento"
  [class.documento--sem-cancelar]="!podeCancelar()"
  [src]="pdfSrc()"
  [textoInformativo]="textoAssinatura()"
  [textoAdicional]="'Termo de adesão'"
></app-pdf-document>

@if (podeCancelar()) {
  <div class="d-flex justify-content-center align-items-center buttons-requerimento">
    <vivest-button variant="secondary" size="md" [disabled]="!requerimento()" (click)="onSubmit()">
      Cancelar solicitação
    </vivest-button>
  </div>
}

<vivest-modal
  #modalCancelar
  heading="Deseja cancelar sua Solicitação?"
  description="Essa ação não poderá ser desfeita"
  dismissible
  [hasIcon]="true"
  [open]="openModal()"
  (vivest-close)="closeModal()"
>
  <img slot="icon" src="assets/images/icons/Cancel.svg" alt="" />
  <vivest-button slot="actions" variant="outline" size="md" (click)="closeModal()">Não, voltar</vivest-button>
  <vivest-button slot="actions" variant="secondary" size="md" (click)="cancelar()">Sim, cancelar</vivest-button>
</vivest-modal>

<vivest-modal
  #modalDocumentacao
  heading="Não conseguimos validar a sua documentação"
  description="Alguns documentos que você nos enviou não puderam ser validados."
  dismissible
  [hasIcon]="true"
  [open]="openDocModal()"
  (vivest-close)="closeDocModal()"
  style="--vivest-modal-width: 664px"
>
  <img slot="icon" src="assets/images/icons/Cancel.svg" alt="" />
  <vivest-button slot="actions" variant="outline" size="md" (click)="closeDocModal()">Fechar</vivest-button>
  <vivest-button slot="actions" variant="secondary" size="md" (click)="openDocPage()">Reenviar documentos</vivest-button>
</vivest-modal>
